"use client";

import { DietCardDesktop } from "@/features/cart/components/configure-diet/diet-card/diet-card-desktop";
import { DietCardMobile } from "@/features/cart/components/configure-diet/diet-card/diet-card-mobile";
import type { DietCatalogDetail } from "@/features/diets/types";
import type { Globals } from "@/features/globals/types/globals.type";

export const DietConfigurationCard = ({
  diet,
  globals,
  variant,
  kcal,
}: {
  diet: DietCatalogDetail;
  globals?: Globals | null;
  variant?: string;
  kcal?: string;
}) => (
  <>
    <div className="hidden md:block">
      <DietCardDesktop
        diet={diet}
        globals={globals}
        kcal={kcal}
        variant={variant}
      />
    </div>
    <div className="block md:hidden">
      <DietCardMobile
        diet={diet}
        globals={globals}
        kcal={kcal}
        variant={variant}
      />
    </div>
  </>
);
